export const getConfigurationsSelector = state => state?.Auth?.configuration;
export const getUserSelector = state => state?.Auth?.user;
export const getReferalSelector = state => state?.referal;
export const getFromValueSelector = state => state?.transfer?.formValues;
export const getFormAttributesSelector = state => state?.transfer.pocFormAttribute;
export const imagesSelector = state => state?.images?.images;
